import { PROMO_REDEMPTION_STATUSES } from '@steado/admin-contract/promotions';
import { z } from 'zod';

/** Archived campaigns stay out of the list unless asked for, as the API does. */
export const promotionsSearchSchema = z.object({
  archived: z.boolean().optional().catch(undefined),
});

export type PromotionsSearch = z.infer<typeof promotionsSearchSchema>;

/** One campaign's redemptions, filtered and paged from the URL. */
export const promotionDetailSearchSchema = z.object({
  status: z.enum(PROMO_REDEMPTION_STATUSES).optional().catch(undefined),
  cursor: z.string().optional().catch(undefined),
});

export type PromotionDetailSearch = z.infer<typeof promotionDetailSearchSchema>;
